import React, { useState, useEffect } from 'react';

const API = 'http://localhost:8000/api/v1';

function S1Invoices() {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    fetch(API + '/s1/invoices')
      .then(r => r.json())
      .then(d => setInvoices(d.invoices || []));
  }, []);

  return (
    <div>
      <h2>1С: Счета</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        {invoices.length > 0 ? 'Демо-режим — подключите реальную 1С в Настройках' : 'Загрузка...'}
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Номер</th>
            <th style={{ padding: 8 }}>Дата</th>
            <th style={{ padding: 8 }}>Контрагент</th>
            <th style={{ padding: 8, textAlign: 'right' }}>Сумма</th>
            <th style={{ padding: 8 }}>Статус</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((inv, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{inv.number}</td>
              <td style={{ padding: 8 }}>{inv.date}</td>
              <td style={{ padding: 8 }}>{inv.counterparty}</td>
              <td style={{ padding: 8, textAlign: 'right' }}>{inv.amount.toLocaleString()} ₽</td>
              <td style={{ padding: 8, color: inv.status === 'paid' ? '#10B981' : '#F59E0B' }}>
                {inv.status === 'paid' ? '● Оплачен' : '○ Не оплачен'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default S1Invoices;